export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AvisoEvaluacionDocente.vue?vue&type=template&id=36358914&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/AvisoEvaluacionDocente.vue?vue&type=template&id=36358914&scoped=true&
// module id = 591
// module chunks = 0